(() => {
  const legacyResources = new Set([
    'south-kaibab-to-north-kaibab-audio-trail-guide',
    'north-kaibab-to-bright-angel-audio-trail-guide',
    'rim-to-rim-beginners-guide',
  ]);
  const source = 'https://www.nps.gov/grca/planyourvisit/key-messages.htm';

  function createNotice() {
    const note = document.createElement('p');
    note.className = 'hikin-legacy-notice';
    note.dataset.hikinLegacyNotice = '';
    const label = document.createElement('strong');
    label.textContent = 'Legacy rim-to-rim resource';
    const text = document.createTextNode('This route is currently unavailable. Use this guide for background learning, not current access advice. ');
    const link = document.createElement('a');
    link.href = source;
    link.textContent = 'Check current NPS trail alerts';
    note.append(label, text, link);
    return note;
  }

  function initialize(root) {
    if (root.dataset.hikinR2rNoticesReady === 'true') return;
    root.dataset.hikinR2rNoticesReady = 'true';
    root.querySelectorAll('[data-vault-resource]').forEach((trigger) => {
      if (!legacyResources.has(trigger.dataset.vaultResource)) return;
      const card = trigger.closest('.hikin-downloads__content');
      if (!card || card.querySelector('[data-hikin-legacy-notice]')) return;
      const description = card.querySelector('.hikin-downloads__description');
      card.insertBefore(createNotice(), description || trigger);
    });
    const capture = root.querySelector('[data-vault-capture]');
    const form = root.querySelector('[data-vault-form]');
    if (!capture || !form) return;
    const modalNote = createNotice();
    modalNote.hidden = true;
    capture.insertBefore(modalNote, form);
    root.addEventListener('click', (event) => {
      const trigger = event.target instanceof Element ? event.target.closest('[data-vault-resource]') : null;
      if (trigger) modalNote.hidden = !legacyResources.has(trigger.dataset.vaultResource);
    }, true);
  }

  function scan() {
    if (!document.querySelector('[data-hikin-r2r-notice]')) return;
    document.querySelectorAll('[data-hikin-vault]').forEach(initialize);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan, { once: true });
  else scan();
  document.addEventListener('shopify:section:load', scan);
})();
